import React from "react";

import { faPlus } from "@performyard/fontawesome/pro-regular-svg-icons";
import { ButtonStandard } from "@performyard/py-components";

type AddCustomThemeButtonProps = {
	onClick: () => void;
	disabled?: boolean;
};

export const AddCustomThemeButton = ({ onClick, disabled = false }: AddCustomThemeButtonProps) => (
	<ButtonStandard
		variant="outline"
		color="neutral"
		size="medium"
		iconLeft={faPlus}
		onClick={onClick}
		disabled={disabled}
		dangerouslySetClassName="w-auto"
	>
		Create Custom Theme
	</ButtonStandard>
);
